export default __webpack_public_path__ + "static/media/css3.486422b1.png";